"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const Text_1 = __importDefault(require("./Text"));
const Tag = ({ variant = 'contained', margin = 'default', backgroundColor = 'default', color = 'default', text, children, }) => {
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([
            styles.container,
            variants[variant],
            backgroundColors[backgroundColor],
            marginStyles[margin],
            { marginLeft: styles_1.getSpacing() },
        ]) },
        react_1.default.createElement(Text_1.default, { variant: "subtitle", margin: "none", color: color }, text),
        children));
};
exports.default = Tag;
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
const variants = react_native_1.StyleSheet.create({
    contained: {
        borderRadius: styles_1.getRadius(),
        paddingHorizontal: styles_1.getSpacing(),
        paddingVertical: styles_1.getSpacing(0.25),
    },
    outlined: {
        borderWidth: styles_1.getSpacing('border'),
        borderColor: styles_1.Colors.primary,
        borderRadius: styles_1.getRadius(),
        paddingHorizontal: styles_1.getSpacing(),
        paddingVertical: styles_1.getSpacing(0.25),
    },
});
const marginStyles = react_native_1.StyleSheet.create({
    default: {
        marginBottom: styles_1.getSpacing(),
    },
    dense: {
        marginBottom: styles_1.getSpacing(0.5),
    },
    none: {
        marginBottom: 0,
    },
});
const backgroundColors = react_native_1.StyleSheet.create({
    default: {
        backgroundColor: styles_1.Colors.background,
    },
    primary: {
        backgroundColor: styles_1.Colors.primary,
    },
    secondary: {
        backgroundColor: styles_1.Colors.secondary,
    },
    green: {
        backgroundColor: styles_1.Colors.green,
    },
    white: {
        backgroundColor: styles_1.Colors.white,
    },
});
